export default Object.freeze({
  KEEP_SINGLE_VOTE_OUTCOMES: 'KEEP_SINGLE_VOTE_OUTCOMES',
  REMOVE_SINGLE_VOTE_OUTCOMES: 'REMOVE_SINGLE_VOTE_OUTCOMES',
  SCREEN_FROM_SINGLE_VOTE: 'SCREEN_FROM_SINGLE_VOTE',
  REQUIRE_CONFIRMING_VOTE: 'REQUIRE_CONFIRMING_VOTE',
});
